module.exports = __webpack_public_path__ + "static/media/walmart_logo.0767b7ae.svg";